module.exports = __webpack_public_path__ + "img/disrupteev.33d384f3.svg";